import type { BuildInfoDto } from '@/api/ApiClient';

export function hasBuildInfo(build: BuildInfoDto | null | undefined): boolean {
  if (!build) {
    return false;
  }
  return !!(build.branch?.trim() || build.commitHash?.trim() || build.buildDate?.trim() || build.version?.trim());
}

/** Labeled rows for About / support (copy-friendly). */
export function buildInfoRows(build: BuildInfoDto): { label: string; value: string }[] {
  const rows: { label: string; value: string }[] = [];
  if (build.branch?.trim()) {
    rows.push({ label: 'Branch', value: build.branch.trim() });
  }
  if (build.commitHash?.trim()) {
    rows.push({ label: 'Build ID', value: build.commitHash.trim() });
  }
  if (build.buildDate?.trim()) {
    rows.push({ label: 'Built on ', value: build.buildDate.trim() });
  }
  return rows;
}
